export const HOME_FAQS = {
  en: [
    {
      q: "What does Shugert do?",
      a: "Shugert is a Shopify Select Partner agency that diagnoses, implements and validates Shopify and Shopify Plus work across performance, CRO, technical SEO, development, applications, integrations, analytics and ongoing engineering.",
    },
    {
      q: "Who do you work with?",
      a: "Shugert is designed for established Shopify and Shopify Plus teams with meaningful storefront, platform or operational complexity. The fit review considers the constraint, dependencies, ownership and required release cadence rather than revenue alone.",
    },
    {
      q: "How much do projects cost?",
      a: "Current project and retainer ranges are published on the Pricing page. Every engagement receives a written scope that explains the assumptions, deliverables, exclusions and review requirements behind the final price.",
    },
    {
      q: "How does an engagement begin?",
      a: "The team first identifies the business decision, affected customer or operational state, current architecture and available evidence. Shugert then recommends the smallest responsible project, retainer or Shopify Plus scope.",
    },
    {
      q: "Do you work in Spanish?",
      a: "Yes. Shugert works in English and Spanish, with bilingual editorial, strategy and engineering support across the United States, Mexico, Spain and Latin America.",
    },
  ],
  es: [
    {
      q: "¿Qué hace Shugert?",
      a: "Shugert es una agencia Shopify Select Partner que diagnostica, implementa y valida trabajo en Shopify y Shopify Plus: rendimiento, CRO, SEO técnico, desarrollo, aplicaciones, integraciones, analítica e ingeniería continua.",
    },
    {
      q: "¿Con quién trabajan?",
      a: "Shugert está diseñado para equipos Shopify y Shopify Plus establecidos con complejidad real de storefront, plataforma u operación. La revisión de encaje considera restricción, dependencias, ownership y cadencia de release, no solo facturación.",
    },
    {
      q: "¿Cuánto cuestan los proyectos?",
      a: "Los rangos actuales de proyectos y retainers están publicados en la página de Precios. Cada engagement recibe un alcance escrito que explica supuestos, entregables, exclusiones y requisitos de revisión.",
    },
    {
      q: "¿Cómo comienza un engagement?",
      a: "Primero identificamos la decisión de negocio, el estado del cliente u operación afectado, la arquitectura actual y la evidencia disponible. Después recomendamos el proyecto, retainer o alcance Shopify Plus mínimo responsable.",
    },
    {
      q: "¿Trabajan en español?",
      a: "Sí. Shugert trabaja en inglés y español, con soporte editorial, estratégico y de ingeniería bilingüe en Estados Unidos, México, España y Latinoamérica.",
    },
  ],
};
